import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MatListModule } from '@angular/material';
import { RouterModule, Routes } from "@angular/router";
import { BreadcrumbModule } from '../components/breadcrumb/breadcrumb.module';
import { TagsInputModule } from '../components/tags-input/tags-input.module';
import { PaginatorComponentModule } from '../components/paginator/paginator.component.module';
import { FilterButtonModule } from "../components/filter-button/filter-button.module";
import { MatTooltipModule } from "@angular/material";
import { TransportPackageCancelledComponent } from './transport-package-cancelled.component';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule, MatGridListModule} from "@angular/material";

import {
  MatCheckboxModule,
  MatPaginatorModule,
  MatRippleModule,
  MatSortModule,
  MatTableModule
} from '@angular/material';
import { NgxFileDropModule } from  'ngx-file-drop' ;
import {PackagesComponent} from "../transport-package-cancelled/packages/packages.component";
import {CdkTableModule} from "@angular/cdk/table";
import {ReceivedProductTemplateComponent} from "./list-items/list-items.component";

const routes: Routes = [
  {
    path: '',
    component: TransportPackageCancelledComponent
  }
];

@NgModule({
  declarations: [TransportPackageCancelledComponent,PackagesComponent,ReceivedProductTemplateComponent],
  entryComponents: [PackagesComponent,ReceivedProductTemplateComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    MatListModule,
    MatTableModule,
    MatPaginatorModule,
    BreadcrumbModule,
    TagsInputModule,
    PaginatorComponentModule,
    FilterButtonModule,
    MatTooltipModule,
    FormsModule,
    MatCheckboxModule,
    MatRippleModule,
    MatSortModule,
    NgxFileDropModule,
    MatTabsModule,
    MatExpansionModule,
    MatGridListModule,
    RouterModule.forChild(routes),
    CdkTableModule,
  ],
})
export class TransportPackageCancelledModule { }
